/**
 * Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
 * Use this package to monitor your web application's performance and user experience.
 *
 * @packageDocumentation
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
// Keep the following in sync with packages/rum-slim/src/entries/main.ts
import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeRumPublicApi, startRum } from '@datadog/browser-rum-core';
import { makeRecorderApi } from '../boot/recorderApi';
import { createDeflateEncoder, startDeflateWorker } from '../domain/deflate';
import { lazyLoadRecorder } from '../boot/lazyLoadRecorder';
import { makeProfilerApi } from '../boot/profilerApi';
export { DefaultPrivacyLevel } from '@datadog/browser-core';
const recorderApi = makeRecorderApi(lazyLoadRecorder);
const profilerApi = makeProfilerApi();
/**
 * The global RUM instance. Use this to call RUM methods.
 *
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
export const datadogRum = makeRumPublicApi(startRum, recorderApi, profilerApi, {
    startDeflateWorker,
    createDeflateEncoder,
    sdkName: 'rum',
});
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map